var CandidateCount = /** @class */ (function () {
    function CandidateCount() {
        this.activeCandidatesCount = 0;
        this.passiveCandidatesCount = 0;
        this.matchedCandidateCount = 0;
        this.unMatchedCandidateCount = 0;
        this.justAddedCandidateCount = 0;
        this.notProcessedCandidateCount = 0;
        this.candidateList = null;
    }
    return CandidateCount;
}());
export { CandidateCount };
//# sourceMappingURL=candidateCount.js.map